import {
  ApolloClient,
  ApolloLink,
  concat,
  HttpLink,
  InMemoryCache,
} from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { StrictTypedTypePolicies } from '@generated/backstageHelper';

type ClientType = 'BACKSTAGE' | 'FRONTSTAGE';
type EndpointsType = Record<ClientType, string>;
type HeadersMappingType = Record<ClientType, Record<string, string>>;
interface SetContextProps {
  headers: Record<string, string>;
}

const httpLink = new HttpLink();

const authLink = new ApolloLink((operation, forward) => {
  const endpoints: EndpointsType = {
    BACKSTAGE: process.env.REACT_APP_BACK_STAGE_GRAPHQL_END_POINT || '',
    FRONTSTAGE: process.env.REACT_APP_FRONT_STAGE_GRAPHQL_END_POINT || '',
  };
  const headersMapping: HeadersMappingType = {
    BACKSTAGE: {
      'gosky-api-key': localStorage.getItem('cdp_t') || '',
      'gosky-project-uuid': localStorage.getItem('cdp_p_id') || '',
    },
    FRONTSTAGE: {
      'gosky-api-key': localStorage.getItem('cdp_front_t') || '',
    },
  };
  const clientType: ClientType = operation.getContext().clientType || '';
  operation.setContext(({ headers }: SetContextProps) => ({
    uri: endpoints[clientType],
    headers: {
      ...headers,
      ...headersMapping[clientType],
    },
  }));
  return forward(operation);
});

const typePolicies: StrictTypedTypePolicies = {
  Project: {
    keyFields: ['uuid'],
  },
  CouponDispatch: {
    keyFields: ['uuid'],
  },
  RouletteEvent: {
    keyFields: ['uuid'],
  },
  Query: {
    fields: {
      couponDispatches: relayStylePagination(),
      rouletteEvents: relayStylePagination(['progress']),
    },
  },
};

export const cache = new InMemoryCache({
  typePolicies,
});

export const client = new ApolloClient({
  link: concat(authLink, httpLink),
  cache,
});
